// 404页面
import React from 'react';
import './index.scss';
import MainHeader from '@/components/mainheader';
import StandaloneBack from '@/components/standaloneback';
import { Layout, Result } from 'antd';
const { Content } = Layout;

const NotFound = () => {
  return (
    <div className="notfound">
      <Layout>
        {/* 头部区域 */}
        <MainHeader />
        <StandaloneBack withHeader />
        {/* 404 主体区 */}
        <Content>
          <Result
            status="404"
            title="404"
            subTitle="当前页面不存在T_T"
          />
        </Content>
      </Layout>
    </div>
  );
};
export default NotFound;
